var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.086,
    height: 150.086,
    viewBox: "0 0 150.086 150.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.511,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#be1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#8b0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#c92d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26177",
    "data-name": "Group 26177",
    transform: "translate(-71 -86.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12487",
    "data-name": "Group 12487",
    transform: "translate(71 86.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9969",
    "data-name": "Group 9969",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 75.043,
    cy: 75.043,
    r: 75.043,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M75.043,4.47a70.573,70.573,0,0,0-49.9,120.476A70.573,70.573,0,1,0,124.946,25.14a70.111,70.111,0,0,0-49.9-20.67m0-4.47A75.043,75.043,0,1,1,0,75.043,75.043,75.043,0,0,1,75.043,0Z",
    fill: "#d11919"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35385",
    "data-name": "Path 35385",
    d: "M-102.324,1170h4.192c.919.113,1.84.21,2.756.342a35.262,35.262,0,0,1,20.158,10.075A35.086,35.086,0,0,1-65,1199.754c.226,1.3.365,2.614.544,3.922v4.193a4.749,4.749,0,0,0-.12.6A33.952,33.952,0,0,1-69.5,1224a35.431,35.431,0,0,1-24.566,16.986c-1.341.254-2.708.376-4.063.558h-4.192c-.5-.057-1.009-.115-1.514-.171a35.049,35.049,0,0,1-16.042-5.762,35.376,35.376,0,0,1-15.562-23.683c-.249-1.34-.375-2.706-.558-4.059v-4.193a4.72,4.72,0,0,0,.121-.606,32.9,32.9,0,0,1,3.263-12.389c5.428-11,14.163-17.753,26.23-20.119C-105.047,1170.3-103.679,1170.183-102.324,1170Zm24.118,51.686a27.106,27.106,0,0,0-3.805-36.159c-10.556-9.494-25.492-8.552-34.189-1.723Zm-6.171,6.119-37.877-37.99a27.118,27.118,0,0,0,2.921,35.368C-108.74,1235.556-93.322,1234.8-84.377,1227.806Z",
    transform: "translate(246.27 -1040.913)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralBlock);
export default __webpack_public_path__ + "static/media/general-block.a4c8ae6e1d128b3b1467ad3f76b0d3dd.svg";
export { ForwardRef as ReactComponent };